import { render, staticRenderFns } from "./LangSelecter.vue?vue&type=template&id=6aee789a&scoped=true&"
import script from "./LangSelecter.vue?vue&type=script&lang=js&"
export * from "./LangSelecter.vue?vue&type=script&lang=js&"
import style0 from "./LangSelecter.vue?vue&type=style&index=0&id=6aee789a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aee789a",
  null
  
)

export default component.exports